import React from 'react';
import { TermsOfService } from '../components/global/termsOfService';
import {Header} from '../components/global/header';
import {Footer} from '../components/global/footer';

const TermsOfServicePage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <TermsOfService />
      <Footer />
    </div>
  );
};

export default TermsOfServicePage;
